// removed by extract-text-webpack-plugin
module.exports = {"text":"styles__text___2KQFx","section":"styles__section___21qge","bold":"styles__bold___2O7aD","italic":"styles__italic___1-GYW","label":"styles__label___IQ7Mz","tableData":"styles__tableData___31Yfa","link":"styles__link___3qx4U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/categoryTabs/engagementForm/answer/styles.css
// module id = 801
// module chunks = 0